import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./Rules.scss";

export interface IRulesProps{
    /**class */
    className?:string;
}

@pureRender
export class Rules extends React.Component<IRulesProps,any>{
    public render(){
        const {className} =this.props;
        const classNameSec=classnames(styles.sec,className);
        return (
            <div className={classNameSec} onClick={this.showRule} ref="rules">
            </div>
        )
    }
    private showRule=()=>{
        let context="";
        window._CONFIG["RULES"].map((item,index)=>{
            context+=`<p>${item}</p>`
        })
        new f2eGameUI.Dialog({
            classNames:{
                component:"rule-pop"
            },
            content:context
        })
        $('.f2e-dialog__body')['mCustomScrollbar']({
            scrollInertia: 50,
            scrollButtons: {
                enable: true
            },
            callbacks: {
                whileScrollingInterval: 10
            }
        });
    }

}

export default Rules;



// WEBPACK FOOTER //
// ./src/components/Rules/Rules.tsx